<template>
  <div>
    <v-list-tile avatar>
      <v-list-tile-avatar size="20">
        <v-icon v-if="graphic.geometry.type == 'point'"
          >esri-icon-map-pin</v-icon
        >
        <v-icon v-if="graphic.geometry.type == 'polyline'"
          >esri-icon-polyline</v-icon
        >
        <v-icon v-if="graphic.geometry.type == 'polygon'"
          >esri-icon-polygon</v-icon
        >
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title
          style="font-size: 12px !important; margin-left: 10px;"
          v-text="
            graphic.attributes.name ? graphic.attributes.name : 'Uten navn'
          "
        ></v-list-tile-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-btn icon small flat @click="zoomToGraphic">
          <v-icon color="blue" style="font-size: 15px;"
            >esri-icon-zoom-in-magnifying-glass</v-icon
          >
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LayerListItemTocGraphicslayerGraphic",
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters(["getSublayerVisibility"]),
    sublayerVisibility() {
      return this.getSublayerVisibility(this.id, this.sublayer.id);
    }
  },
  props: {
    id: String,
    graphic: Object
  },
  methods: {
    ...mapActions(["setSelectedExtent"]),
    zoomToGraphic: function() {
      this.setSelectedExtent(null);
      this.setSelectedExtent(this.graphic.geometry);
    }
  }
};
</script>

<style scoped></style>
